import React from 'react';
import { useSelector } from 'react-redux';

import { Form, DatePicker } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

import { formatDate } from 'utilities/common';

const initialState = {
  ref_code: '',
  sender: '',
  note: '',
  schedule_at: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM-DD'),
  },
};

export const FormInput = ({ data, isLoading, onInputChange}) => {
  const StateForm = useSelector((state) => state?.Form);

  const [{ ref_code, sender, schedule_at, note }, setState] = React.useState(initialState);

  React.useEffect(() => {
    const state = {
      ref_code,
      sender,
      note,
      schedule_at
    };

    onInputChange(state);
  }, [ref_code, sender, schedule_at, note]);

  React.useEffect(() => {
    if (!data) return;

    setState((prevState) => ({
      ...prevState,
      ref_code: data?.ref_code,
      sender: data?.sender,
      note: data?.note,
      schedule_at: {
        default: new Date(data?.schedule_at),
        formatted: formatDate(data?.schedule_at, 'YYYY-MM-DD'),
      },
    }));
  }, [data])

  return isLoading ? (
    <div className="col-md-12 mb-3">
      <div className="padding-20 rounded-2 border">
        <SkeletonsForm count={2} />
      </div>
    </div>
  ) : (
    <>
      <div className="mb-3">
        <div className="padding-20 rounded-2 border row">
          <div className='col-6'>
            <Form.Input
              label="Pengirim"
              type="text"
              required
              value={sender}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  sender: e?.target?.value,
                }))
              }
              error={StateForm?.errors?.sender}
            />

            <div className="mb-3">
              <label className="form-label required">Jadwal Penerimaan</label>
              <div
                className={
                  StateForm?.errors?.schedule_at
                  ? 'border border-danger rounded'
                  : ''
                }
              >
                <DatePicker
                  type="normal"
                  value={schedule_at?.default || null}
                  format="dd/MM/yyyy"
                  onChange={(date) => {
                    setState((prevState) => ({
                      ...prevState,
                      schedule_at: {
                        default: date,
                        formatted: formatDate(date, 'YYYY-MM-DD'),
                      },
                    }));
                  }}
                  isShowTrigger
                />
              </div>
              {StateForm?.errors?.schedule_at && (
                <div
                  className="invalid-feedback"
                  style={{ display: 'block' }}
                >
                  {StateForm?.errors?.schedule_at}
                </div>
              )}
            </div>
          </div>
          <div className='col-6'>
            <Form.Input
              label="Customer Reference Number"
              type="text"
              value={ref_code}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  ref_code: e?.target?.value,
                }))
              }
              error={StateForm?.errors?.ref_code}
            />
            <Form.Textbox
              label="Catatan"
              type="text"
              value={note}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  note: e?.target?.value,
                }))
              }
              error={StateForm?.errors?.note}
            />
          </div>
        </div>
      </div>
    </>
  );
};
